import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function LightMode(props) {
  const { className, size, fill, svgProps } = props;

  const getSize = () => {
    if (size === "inherit") return null;
    if (!size || size === "default") return 16;
    return size;
  };
  const baseSvgProps = {
    xmlns: "http://www.w3.org/2000/svg",
    className: classNames("manicon-svg", className),
    width: getSize(),
    height: getSize(),
    viewBox: "-4 -4 24 24",
    fill
  };
  return (
    <svg {...baseSvgProps} {...svgProps}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9497 8.00032C11.9497 6.23206 10.5179 4.80026 8.74968 4.80026C6.98234 4.80026 5.54963 6.23206 5.54963 8.00032C5.54963 9.76858 6.98234 11.2004 8.74968 11.2004C10.5179 11.2004 11.9497 9.76858 11.9497 8.00032ZM8.06441 2.59844C8.06441 2.97697 8.37162 3.28417 8.75014 3.28417C9.12866 3.28417 9.43586 2.97697 9.43586 2.59844V0.685726C9.43586 0.307205 9.12866 0 8.75014 0C8.37162 0 8.06441 0.307205 8.06441 0.685726V2.59844ZM9.43586 13.4022C9.43586 13.0237 9.12866 12.7165 8.75014 12.7165C8.37162 12.7165 8.06441 13.0237 8.06441 13.4022V15.3149C8.06441 15.6934 8.37162 16.0006 8.75014 16.0006C9.12866 16.0006 9.43586 15.6934 9.43586 15.3149V13.4022ZM3.34844 7.31459H1.43573C1.05721 7.31459 0.75 7.6218 0.75 8.00032C0.75 8.37884 1.05721 8.68605 1.43573 8.68605H3.34844C3.72696 8.68605 4.03417 8.37884 4.03417 8.00032C4.03417 7.6218 3.72696 7.31459 3.34844 7.31459ZM14.1516 7.31459C13.773 7.31459 13.4658 7.6218 13.4658 8.00032C13.4658 8.37884 13.773 8.68605 14.1516 8.68605H16.0643C16.4428 8.68605 16.75 8.37884 16.75 8.00032C16.75 7.6218 16.4428 7.31459 16.0643 7.31459H14.1516ZM4.93046 4.86637C4.75491 4.86637 4.57937 4.79962 4.44588 4.66522L3.09271 3.31297C2.82482 3.04508 2.82482 2.61079 3.09271 2.3429C3.3606 2.07501 3.7949 2.07501 4.06279 2.3429L5.41504 3.69606C5.68293 3.96395 5.68293 4.39733 5.41504 4.66522C5.28155 4.79962 5.10601 4.86637 4.93046 4.86637ZM14.4065 12.6875L13.0542 11.3352C12.7863 11.0673 12.352 11.0673 12.0841 11.3352C11.8162 11.6031 11.8162 12.0374 12.0841 12.3053L13.4373 13.6576C13.5708 13.792 13.7463 13.8587 13.9219 13.8587C14.0974 13.8587 14.273 13.792 14.4065 13.6576C14.6744 13.3897 14.6744 12.9554 14.4065 12.6875ZM4.44561 11.3352C4.7135 11.0673 5.14779 11.0673 5.41568 11.3352C5.68357 11.6031 5.68357 12.0374 5.41568 12.3053L4.06251 13.6576C3.92903 13.792 3.75348 13.8587 3.57793 13.8587C3.40239 13.8587 3.22684 13.792 3.09335 13.6576C2.82546 13.3897 2.82546 12.9554 3.09335 12.6875L4.44561 11.3352ZM12.5696 4.86655C12.7452 4.86655 12.9207 4.79889 13.0542 4.66541L14.4065 3.31315C14.6744 3.04526 14.6744 2.61097 14.4065 2.34308C14.1395 2.07519 13.7052 2.07519 13.4373 2.34308L12.0841 3.69533C11.8162 3.96322 11.8162 4.39752 12.0841 4.66541C12.2185 4.79889 12.3941 4.86655 12.5696 4.86655Z"
      />
    </svg>
  );
}

LightMode.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  stroke: PropTypes.string,
  fill: PropTypes.string,
  svgProps: PropTypes.object
};

export default LightMode;
